module.exports = __webpack_public_path__ + "img/opal_sloneczny.6b0c2718.jpg";